import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';

/** Compact header for standalone pages. Adds a "Back to Owner center" link when opened from the Owner Center. */
export function PageHeader() {
  const location = useLocation();
  const fromOwner = Boolean((location.state as {
    fromOwner?: boolean;
  } | null)?.fromOwner);
  return <>
      <header className="sticky top-0 z-40 border-b border-white/10 bg-ink-950/95 backdrop-blur" data-id="element-1039" data-mp="2ypopbzukyi85">
        <div className="mx-auto flex max-w-[1400px] items-center justify-between gap-4 px-4 py-3 sm:px-6 lg:px-8" data-id="element-1040" data-mp="2tr3n5uvrpoh2">
          <Link to="/" className="shrink-0" data-id="element-1041" data-mp="38fztnni6etfk">
            <span className="block font-display text-2xl font-extrabold uppercase leading-none tracking-tight text-offwhite sm:text-3xl" data-id="element-1042" data-mp="38huhb9ku0znc">
              Grit<span className="text-grit-500" data-id="element-1043" data-mp="2fyx7sb0fvlio">Vue</span>
              <sup className="ml-0.5 align-super text-[9px] text-steel-400" data-id="element-1044" data-mp="2fxce0nly86lv">™</sup>
            </span>
            <span className="mt-0.5 block text-[8px] font-semibold uppercase tracking-[0.3em] text-steel-400 sm:text-[9px]" data-id="element-1045" data-mp="2ay9ko0fbzotq">
              See the job through
            </span>
          </Link>
          <Link to="/#offer" className="inline-flex shrink-0 items-center bg-grit-500 px-3.5 py-2.5 font-display text-base font-extrabold uppercase leading-none tracking-wide text-ink-950 transition-[background-color,transform] duration-150 ease-grit hover:bg-grit-400 active:translate-y-[2px] sm:px-4 sm:text-lg" data-id="element-1046" data-mp="2lygy81nndy2k">
            Get your X1
          </Link>
        </div>
      </header>
      {fromOwner && <div className="bg-ink-950" data-id="element-1047" data-mp="2809564tqfgwo">
          <div className="mx-auto max-w-[1400px] px-4 pt-6 sm:px-6 lg:px-8" data-id="element-1048" data-mp="27z7jl6f3bc0p">
            <Link to="/owner" className="inline-flex items-center gap-2 text-[13px] font-bold uppercase tracking-[0.16em] text-steel-300 transition-colors duration-150 ease-grit hover:text-grit-500 focus:outline-none focus-visible:ring-2 focus-visible:ring-grit-500" data-id="element-1049" data-mp="2d0wv0n685rpb">
              <ArrowLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-1050" data-mp="2yplisrq5htjz" />
              Back to Owner center
            </Link>
          </div>
        </div>}
    </>;
}